﻿window.S4 = function () {
    return (((1 + Math["random"]()) * 0x10000) | 0).toString(16).substring(1);
};

window.guid = function () {
    return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
};

window.refreshCaptcha = function (imageId) {
    var image = document.getElementById(imageId);
    if (image) {
        var baseAddress = image.src;

        if (baseAddress.indexOf("&random=") == -1)
            image.src = baseAddress + "&random=" + guid();
        else
            image.src = baseAddress.substr(0, baseAddress.indexOf("&random=")) + "&random=" + guid();
    }
};


//////////////////
// WEBPACK FOOTER
// ./libs/captchaScripts.js
// module id = 740
// module chunks = 1